<template>
  <div
    class="d-flex align-items-start position-relative vid-inner-wrap"
    :class="[{ playing: playing }, data.posterPos === 'right' ? 'justify-content-end' : '', data.class]"
  >
    <video
      class="position-absolute absolute-center w-100 vid"
      @play="playing = true"
      @playing="playing = true"
      @pause="playing = false"
      @ended="playing = false"
      ref="vid"
      fullscreen
      controls
    >
      <source v-for="src in data.vidSrc" :src="src" :type="'video/' + src.split('.').pop()">
    </video>

    <img
      :src="poster"
      :alt="data.sub"
      class="position-relative fade-on-play mw-100 vid-poster"
    >

    <div
      class="position-absolute fade-on-play grad"
      :style="{ [data.gradPos[0]]: 0, [data.gradPos[1]]: 0, background: grad }"
    ></div>

    <div class="position-absolute absolute-center fade-on-play play-btn" @click="play"></div>

    <div class="position-absolute fade-on-play vid-text">
      <h4 class="text-uppercase knockout-50 mt-0 mb-1 vid-title" :style="{ color: mainColor }" v-html="data.title"></h4>
      <p class="my-0 adobe-italic vid-sub" v-html="data.sub"></p>
    </div>
  </div>
</template>

<script>
  import { hexToRgba } from '@/lib/funcs'
  import fscreen from 'fscreen'
  import ContentMixin from '@/components/report/mixins/ContentMixin'

  export default {
    name: 'Vid',
    mixins: [ ContentMixin ],
    data () { return { playing: false, poster: '' } },
    computed: {
      grad () {
        let dir = this.data.gradPos[ 0 ] === 'top' ? 'bottom' : 'top'
        return 'linear-gradient(to ' + dir + ', ' + hexToRgba( this.accent ) + ' 0%, ' + hexToRgba( this.accent, 0 ) + ' 100%)'
      }
    },
    watch: {
      data () {
        this.$nextTick( () => this.setPoster() )
      },

      colorIdx () {
        this.$nextTick( () => this.setPoster() )
      }
    },
    methods: {
      play () {
        this.$refs.vid.play()
        if ( this.isMobile ) fscreen.requestFullscreen( this.$refs.vid )
      },

      setPoster () {
        this.poster = require( `@/assets/img/posters/${this.data.poster}_${this.colorIdx + 1}.jpg` )
      }
    },
    mounted () {
      this.setPoster()

      fscreen.addEventListener( 'fullscreenchange', () => {
        if ( fscreen.fullscreenElement === null ) this.$refs.vid.pause()
      }, false )
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .raised-vid-txt {
    margin-bottom : viewport-scale(90);
  }

  .vid-content-wrap {
    padding-bottom : rem(80);

    @include screen-md-lg-xl {
      width     : 100%;
      max-width : 690px;
      margin    : 0 auto;
    }
  }

  .vid-inner-wrap {
    .play-btn {
      background    : $adobe-blue;
      width         : rem(88);
      height        : rem(88);
      border-radius : 50%;

      .raised-vid-txt & {
        @include screen-xs-sm {
          top : 35%;
        }
      }

      &::after {
        $border-x : rem(28.12) solid transparent;
        $border-y : rem(17.375) solid transparent;
        content           : '';
        position          : absolute;
        top               : 50%;
        left              : 56%;
        transform         : translate(-50%, -50%);
        width             : 0;
        height            : 0;
        border-top        : $border-y;
        border-bottom     : $border-y;
        border-right      : none;
        border-left       : $border-x;
        border-left-color : #fff;
        z-index           : 15;
      }

      @include screen-md-lg-xl {
        width  : rem(70);
        height : rem(70);
      }
    }

    .grad {
      opacity : 0.8;
      width   : 50%;
      height  : 75%;

      @include screen-md-lg-xl {
        width  : 46%;
        height : 110%;
        margin : -25px 25px;
      }
    }

    .vid {
      opacity : 0;

      @include screen-md-lg-xl {
        height : 100%
      }

      .playing & {
        opacity : 1;
      }

      &-inner-wrap {
        padding : 1.5rem 0;
      }

      &-text {
        background : #fff;
        left       : 0;
        width      : 58.4%;
        bottom     : calc(1.5rem + #{rem(26)});
        padding    : rem(20);

        @include screen-md-lg-xl {
          width : 60%;
        }

        @include screen-md-lg {
          left : 0;
        }
      }

      &-title {
        font-size      : rem(14);
        letter-spacing : 0.1428em;

        @include screen-md-lg-xl {
          font-size      : rem(16);
          line-height    : rem(19);
          letter-spacing : rem(2.29);
        }
      }

      &-sub {
        color       : #000;
        font-size   : rem(18);
        line-height : 1.333;

        @include screen-md-lg-xl {
          font-size   : rem(24);
          line-height : rem(30);
        }
      }

      &-poster {
        width : 95%;

        @include screen-md-lg-xl {
          width  : auto;
          margin : 0 auto;
        }
      }
    }

    .fade-on-play {
      transition : opacity 0.75s;
    }

    &.playing {
      .vid {
        opacity : 1;
      }

      .fade-on-play {
        opacity        : 0;
        pointer-events : none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Vid.vue